import React from 'react';

/* 64x24, 1.5px, no axes, no fill. --profit if the series ends above where it
   started, --loss if below. The only place profit/loss colour appears without a
   sign — acceptable because the shape itself carries direction, which is a
   non-colour channel. */

export function Sparkline({ data = [], width = 64, height = 24, muted = false, style }) {
  if (data.length < 2) return <svg width={width} height={height} style={style} aria-hidden="true" />;
  const min = Math.min(...data), max = Math.max(...data);
  const span = max - min || 1;
  const pts = data.map((v, i) => {
    const x = (i / (data.length - 1)) * (width - 2) + 1;
    const y = height - 1 - ((v - min) / span) * (height - 2);
    return x.toFixed(2) + ',' + y.toFixed(2);
  }).join(' ');
  const up = data[data.length - 1] >= data[0];
  const stroke = muted ? 'var(--border-subtle)' : (up ? 'var(--profit)' : 'var(--loss)');

  return (
    <svg width={width} height={height} viewBox={'0 0 ' + width + ' ' + height} aria-hidden="true"
      style={{ display: 'block', overflow: 'visible', ...style }}>
      <polyline points={pts} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
